import { render, staticRenderFns } from "./TqToggleSwitch.vue?vue&type=template&id=7d748564&scoped=true&"
import script from "./TqToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./TqToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TqToggleSwitch.vue?vue&type=style&index=0&id=7d748564&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d748564",
  null
  
)

export default component.exports